import type { FC } from 'react';
import { useCallback, lazy, Suspense } from 'react';
import InfoHeader from './components/InfoHeader';
import MainHeader from './components/MainHeader';
import RegisterOrderHeader from './components/RegisterOrderHeader';
import AuthModals from '@components/Modals/AuthModals/component';
import { observer } from 'mobx-react';
import { useHistory, useParams, type RouteProps } from '@compat/router';
// рендерится по условию → lazy (уедет из main вместе с импортом в MainHeader)
const MergeCartsModal = lazy(async () => await import('@components/Modals/MergeCartsModal'));
import BarMenuConsentModal from '@routes/BarMenu/layout/BarMenuConsentModal';
import { useStores } from '@root/src/stores';

interface HeadersWrapperProps {
  isOnlyMainHeader?: boolean;
  path: RouteProps['path'];
}

const HeadersWrapper: FC<HeadersWrapperProps> = observer(
  ({ isOnlyMainHeader, path }) => {
    const { userStore, modalsStore } = useStores();
    const { isUserLoggedIn } = userStore;
    const { showLoginModal, showMergeModal, isConsentModalOpened } =
      modalsStore;
    const history = useHistory();
    const { barId, tableId } = useParams<{
      barId: string;
      tableId: string;
    }>();

    const onDenyConsentModal = useCallback(() => {
      if (path?.includes('/bar-menu/')) {
        history.replace(`/bar-menu/${barId}/${tableId}`);
      } else {
        history.replace('/');
      }
    }, [barId, history, path, tableId]);

    if (path === '/cart/order') {
      return (
        <>
          {!isUserLoggedIn && showLoginModal && <AuthModals />}
          {isConsentModalOpened && (
            <BarMenuConsentModal onDeny={onDenyConsentModal} open />
          )}
          <RegisterOrderHeader />
          {showMergeModal && (
            <Suspense fallback={null}>
              <MergeCartsModal />
            </Suspense>
          )}
        </>
      );
    }
    return (
      <>
        {!isOnlyMainHeader && <InfoHeader />}
        {!isUserLoggedIn && showLoginModal && <AuthModals />}
        {isConsentModalOpened && (
          <BarMenuConsentModal onDeny={onDenyConsentModal} open />
        )}
        <MainHeader isOnlyMainHeader={isOnlyMainHeader} />
      </>
    );
  }
);

export default HeadersWrapper;
